import './videoSec.css';
import Slider from "react-slick";
import TelematicsVideoPlayer from "../videoTelematicsComponent/telematicsVideoPlayer/telematicsVideoPlayer";
import {useState} from "react";
import {videos} from "../../data/videosData";

const VideoSec = ({isDVR = false}) => {

    const [showVideoPlayer, setShowVideoPlayer] = useState(false);
    const [videoIndex, setVideoIndex] = useState(0);

    const settings = {
        dots: false,
        infinite: true,
        slidesToShow: 3,
        slidesToScroll: 3,
        arrows: true,
    };

    const handleShowVideoPlayer = (val, index) => {
        setShowVideoPlayer(val);
        setVideoIndex(+index);
        window.scroll({
            top: 0,
            behavior: 'smooth'
        });
    }

    return(
        <>
            <ul className={'coaching-videos-sec'}>
                <Slider  {...settings}>
                    {videos.map((video, index) =>
                        <li className={`slide-box ${isDVR ? 'not-seen' : ''}`} key={index}
                            onClick={e => handleShowVideoPlayer(true, index)}>
                            <div className="content">
                                <div className="icon width-block-100 margin-b-20">
                                    <img src={video.img} alt=""/>
                                </div>
                                <div className="sf-medium font-14 flex gap-10">
                                    <div className="rating-box red-box">{video.tag}</div>
                                    <ul className={'separator gap-20'}>
                                        <li><span className={'margin-r-5'}>19:27</span> 15 Sep 2023</li>
                                        <li> Driver:  <span className={'highlight-color'}>Babu K</span></li>
                                    </ul>
                                </div>
                            </div>
                        </li>
                    )}

                </Slider>
            </ul>

            {/*..... telematics video player ......*/}
            {showVideoPlayer && <TelematicsVideoPlayer index={videoIndex} handleShowVideoPlayer={handleShowVideoPlayer} />}
        </>
    )
}
export default VideoSec;
